export default {
  label: '列表布局选择',
  labelSwitch: true,
  type: 'layoutSource',
  property: '',
  value: {
    layoutType: 'list-top-bottom',
  },
};
